import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NbButtonModule, NbIconModule, NbPopoverModule, NbTooltipModule } from '@nebular/theme';

@Component({
  selector: 'app-more-details-cell',
  templateUrl: './more-details-cell.component.html',
  styleUrls: ['./more-details-cell.component.css'],
  imports: [NbTooltipModule, NgIf, NbButtonModule, NbPopoverModule, NbIconModule]
})
export class MoreDetailsCellComponent implements OnInit {
  public _value: any = '{}';

  @Input() set value(value: any) {
    value = this.removeEmpty(value);
    this._value = JSON.stringify(value, null, 4);
  }

  constructor() {}

  public ngOnInit() {}

  private removeEmpty(obj) {
    const newObj = {};
    if (obj) {
      Object.entries(obj).forEach(([k, v]) => {
        if (v === Object(v)) {
          newObj[k] = this.removeEmpty(v);
        } else if (v != null) {
          newObj[k] = obj[k];
        }
      });
    }
    return newObj;
  }
}
